import { SortItem } from '@tanium/react-stacked-ribbon-list';

// Since these functions return a static value function. We can ignore the code coverage
/* istanbul ignore next */
export function alwaysTrueOp(): boolean {
  return true;
}

/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}

export function sortData<T>(sortState: SortItem[], values: T[]): T[] {
  if (sortState.length) {
    const { dataKey, sortDirection } = sortState[0];
    const property = dataKey as keyof T;
    const asc = sortDirection === 'ASC' ? 1 : -1;
    const compareFn = (a: T, b: T) => (a[property]! > b[property]! ? asc : asc * -1);
    return values.sort(compareFn);
  }
  return values;
}

export function removeEmptyObjectValues(obj: Record<string, any>) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined && v !== ''));
}
